// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3y-2";
export var blackBorderOnHover = "_3y-7";
export var cell = "_3y-6";
export var cellContainer = "_3y-3";
export var checked = "_3y-8";
export var disabled = "_3y-5";
export var featuredIconCellContainer = "_3y-9";
export var featuredIconTextContainer = "_3y-b";
export var featuredIconWrapper = "_3y-a";
export var noBorder = "_3y-c";
export var orangeSelectedRow = "_bv-3";
export var overflowableText = "_3y-0";
export var overflowableTextContainer = "_3y-1";
export var row = "_3v-0";
export var rowCheckboxCell = "_3y-4";
export var selectableTable = "_bv-2";